const judgementInfoCategories = [
  {
    id: 'jap',
    mock: [
      '101',
      '102',
      '103',
      '110',
      '130',
    ],
    center: [
      '106',
      '113',
      '133',
      '143',
    ],
  },
  {
    id: 'math',
    mock: [
      '203',
      '202',
      '201',
    ],
    center: [
      '221',
      '222',
      '223',
      '224',
    ],
  },
  {
    id: 'eng',
    mock: [
      '301',
    ],
    center: [
      '301',
      '311',
    ],
  },
  {
    id: 'soci',
    mock: [
      '412',
      '422',
      '432',
      '453',
      '451',
      '452',
      '454',
    ],
    center: [
      '411',
      '412',
      '421',
      '422',
      '431',
      '432',
      '453',
      '451',
      '452',
      '454',
    ],
  },
  {
    id: 'scie',
    mock: [
      '512',
      '522',
      '532',
      '542',
      '513',
      '523',
      '533',
      '543',
    ],
    center: [
      '512',
      '522',
      '532',
      '542',
      '513',
      '523',
      '533',
      '543',
    ],
  },
];



export default judgementInfoCategories;



// WEBPACK FOOTER //
// ./src/js/constants/judgementInfoCategories.js